function ImageWrapper() {
    return <div className="image-wrapper"></div>;
}

export default ImageWrapper;
